import { BsSearch,BsSunFill,BsFillMoonStarsFill } from 'react-icons/bs';
import {GoThreeBars} from 'react-icons/go';
import { useDispatch,useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
const PhoneNavBar = ()=>{

    const dispatch = useDispatch();
    const location = useLocation();
    const mode = useSelector(state=>state.ModeReducer);

    const handleOpen = ()=>{
        console.log('clicked')
        dispatch({type:'OPEN'})
    }

    const handleMode = ()=>{
        dispatch({type:'MODE'})
    }

    return <nav className='fixed top-0 right-0 left-0 z-20 bg-background dark:bg-background-dark flex flex-row justify-between items-center px-2 py-2 text-headline dark:text-headline-dark text-md font-heading shadow-md md:hidden'>
        <button onClick={handleOpen}>
            <GoThreeBars onClick={handleOpen}/>
        </button>
        <h3>{(location.pathname==='/')?'/Home':location.pathname}</h3>
        <span className='flex flex-row items-center'>

            <Link to={"/Search"} className='mr-2'>
                <BsSearch/>
            </Link>
            <button onClick={handleMode}>
                    {
                        (mode)?
                        <BsSunFill className='text-[orange]'/>
                        :
                        <BsFillMoonStarsFill/>
                    }
            </button>
        </span>
    </nav>
}

export default PhoneNavBar;